export default __webpack_public_path__ + "static/media/acumenLogoSmall.9c0148b7.svg";